import {
  createTheme,
  responsiveFontSizes,
  makeStyles
} from '@material-ui/core/styles';

const useStyle = makeStyles((theme) => {
  return ({
    root: {
      position: 'relative',
      width: 'auto',
      minHeight: '400px',
      // display: 'flex',
      marginLeft: theme.spacing(2),
      marginRight: theme.spacing(2),
      [theme.breakpoints.up(808 + theme.spacing(2) * 2)]: {
        width: '80vw',
        marginLeft: 'auto',
        marginRight: 'auto',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
      },
      backgroundColor: 'transparent'
    },
    paper: {
      marginTop: theme.spacing(3),
      marginBottom: theme.spacing(3),
      borderRadius: 15,
      minHeight: '400px',
      padding: theme.spacing(2),
      [theme.breakpoints.up(808 + theme.spacing(3) * 2)]: {
        marginTop: theme.spacing(6),
        marginBottom: theme.spacing(6),
        padding: theme.spacing(3)
      }
    },
    details: {
      display: 'flex',
      flexDirection: 'column'
    },
    content: {
      flex: '1 0 auto'
    },
    cover: {
      width: 151
    },
    controls: {
      display: 'flex',
      alignItems: 'center',
      paddingLeft: theme.spacing(1),
      paddingBottom: theme.spacing(1)
    },
    playIcon: {
      height: 38,
      width: 38
    }
  })
});

export { useStyle };
